module.exports = __webpack_public_path__ + "static/img/application15-4.f8e6114.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application15-4.jpg
// module id = UkkP
// module chunks = 0